const SUP_ASSET=(p)=>(window.SUPREMES_GAME_ASSETS&&window.SUPREMES_GAME_ASSETS[p])||p;
const S = 1500;
const SPEED = 375;
let selectedCharacter = "queen";



const CHARACTERS = {
me:{label:"ME EVERYDAY",folder:"ME",copy:"Free to play. Explore the Office.",pfp:SUP_ASSET('pfp-me.png'),sit:"me-sit",sourceSize:[244,494]},
queen:{label:"QUEEN",folder:"Queen",copy:"The allowlist is now closed.",pfp:SUP_ASSET('pfp-queen.png'),sit:"queen-sit",sourceSize:[275,494]},
genzee:{label:"GENZEE",folder:"Genzee",copy:"Exclusive to Genzee holders.",pfp:SUP_ASSET('pfp-genzee.png'),sit:"genzee-sit",sourceSize:[257,494]}};
const PLAYER_HEIGHT=300;

// ============================================================
// PLAYER SELECT — EASY MANUAL ADJUSTMENTS
// ============================================================
// 1.00 = same size as gameplay
// 1.20 = 20% larger
// 1.25 = 25% larger, etc.
const PLAYER_SELECT_SCALE = 1.00;

// Vertical position ONLY on Player Select.
// Negative = move characters UP. Positive = move them DOWN.
const PLAYER_SELECT_Y_OFFSET = -100;
// ============================================================

const scaledSize=id=>{const [w,h]=CHARACTERS[id].sourceSize;return [Math.round(PLAYER_HEIGHT*w/h),PLAYER_HEIGHT]};
const selectScaledSize=id=>{const [w,h]=CHARACTERS[id].sourceSize;const sh=Math.round(PLAYER_HEIGHT*PLAYER_SELECT_SCALE);return [Math.round(sh*w/h),sh]};
const idle=(id,d)=>`${id}-${d}-idle`, walk=(id,d,n)=>`${id}-${d}-${String(n).padStart(2,"0")}`;

const POS = {
  playerStart: { x: 750, y: 1180 }, dog:{x:210,y:550}, statue:{x:1285,y:475}, chair:{x:742,y:405},
  wooddoor:{x:775,y:77,scale:1}, secretWall:{x:700,y:126,scale:1},
  arrow:{ dog:{x:185,y:360}, paper:{x:590,y:455}, money:{x:915,y:455}, portrait:{x:495,y:145},
    artwork:{x:938,y:125}, statue:{x:1285,y:225}, exit:{x:650,y:1320}, chair:{x:742,y:345}, intern:{x:1120,y:790} }
};
const ZONES = {
  dog:{x:205,y:510,w:300,h:260}, chair:{x:742,y:650,w:220,h:190}, paper:{x:590,y:520,w:250,h:230},
  money:{x:915,y:520,w:250,h:230}, portrait:{x:495,y:260,w:300,h:260}, artwork:{x:938,y:360,w:300,h:280},
  statue:{x:1280,y:455,w:300,h:300}, exit:{x:650,y:1290,w:360,h:260}, intern:{x:1120,y:1030,w:300,h:330}
};

function msg(title, copy="", controls=true){
  window.dispatchEvent(new CustomEvent("supremes-message",{detail:{title,copy,controls}}));
}
function playerUI(name,selectMode=false){ window.dispatchEvent(new CustomEvent("supremes-player",{detail:{name,selectMode}})); }
function locationUI(location){ window.dispatchEvent(new CustomEvent("supremes-location",{detail:{location}})); }

class BaseScene extends Phaser.Scene {
preloadCommon(){this.load.image("arrow",SUP_ASSET('arrow.png'));for(const [id,ch] of Object.entries(CHARACTERS))for(const d of ["front","back","left","right"]){this.load.image(idle(id,d),SUP_ASSET(`${ch.folder}/${id}-${d}-idle.png`));for(let n=1;n<=5;n++)this.load.image(walk(id,d,n),SUP_ASSET(`${ch.folder}/${id}-${d}-${String(n).padStart(2,"0")}.png`));}this.load.image("queen-sit",SUP_ASSET('Queen/queen-sit.png'));this.load.image("me-sit",SUP_ASSET('ME/me-sit.png'));this.load.image("genzee-sit",SUP_ASSET('Genzee/genzee-sit.png'));}
makeWalkAnims(id){for(const d of ["front","back","left","right"])this.anims.create({key:`${id}-walk-${d}`,frames:[1,2,3,4,5].map(n=>({key:walk(id,d,n)})),frameRate:9,repeat:-1});}
}

class SelectScene extends BaseScene {
constructor(){super("select");}
init(data){this.returning=!!(data&&data.returning);}
preload(){this.preloadCommon();this.load.image("select-bg",SUP_ASSET('playerselect-mansion.png'));}
create(){this.busy=!!this.returning;document.getElementById("supremes-game-shopify")?.classList.remove("mobile-office");locationUI("OUTSIDE");
if(isSupMobile){this.cameras.main.setViewport(0,0,S,S);this.cameras.main.setZoom(1.6);this.cameras.main.centerOn(770,670);}this.index=Math.max(0,["me","queen","genzee"].indexOf(selectedCharacter));this.add.image(750,750,"select-bg");["me","queen","genzee"].forEach(id=>this.makeWalkAnims(id));this.xs=[430,750,1070];this.y=1040+PLAYER_SELECT_Y_OFFSET;this.sprites=[0,1,2].map(()=>this.add.sprite(0,this.y).setDepth(20));this.keys=this.input.keyboard.addKeys({left:37,right:39,up:38,a:65,enter:13});
this.rainGroundY=1120;
this.rain=Array.from({length:480},()=>({x:Phaser.Math.Between(-100,S+180),y:Phaser.Math.Between(-420,this.rainGroundY-30),len:Phaser.Math.Between(18,42),speed:Phaser.Math.Between(720,1180)}));
this.rainG=this.add.graphics().setDepth(15);
this.splashes=[];
this.splashG=this.add.graphics().setDepth(19);
// Every visible rain streak now terminates on the same ground plane around the
// characters and creates its own tiny impact splash there. Nothing rains below it.
this.splashBand={x1:260,x2:1240,y1:this.rainGroundY-3,y2:this.rainGroundY+3};
// Camera flash is used for lightning so the flash is guaranteed to render over
// the complete game, including UI and sprites.
this.nextThunder=Phaser.Math.Between(6500,12000);
this.refresh(true);
this.time.delayedCall(120,()=>{
  if(window.owRenderSelect)window.owRenderSelect();
  else if(window.owStartSelect)window.owStartSelect();
});
msg("CHOOSE YOUR PLAYER.","← / → CHANGE  ·  ENTER / A SELECT",true);
if(this.returning){
  // Returning from the Office: fade the outside scene in, then let the currently
  // selected character take only a few quick steps back into the center slot.
  const h=this.sprites[1];
  h.setTexture(idle(selectedCharacter,"front")).setDisplaySize(...scaledSize(selectedCharacter)).clearTint().setVisible(true).setPosition(this.xs[1],865);
  this.sprites[0].setVisible(true);this.sprites[2].setVisible(true);
  h.anims.play(`${selectedCharacter}-walk-front`,true);
  this.cameras.main.fadeIn(260,0,0,0);
  this.tweens.add({targets:h,y:this.y,duration:360,ease:"Linear",onComplete:()=>{
    h.anims.stop();h.setTexture(idle(selectedCharacter,"front")).setDisplaySize(...selectScaledSize(selectedCharacter));this.busy=false;
  }});
}
}
ids(){const o=["me","queen","genzee"];return [o[(this.index+2)%3],o[this.index],o[(this.index+1)%3]];}
refresh(now=false){ window.owActiveSelectScene=this;const ids=this.ids();this.sprites.forEach((sp,i)=>{const id=ids[i];sp.setTexture(idle(id,"front")).setDisplaySize(...selectScaledSize(id)).clearTint().setAlpha(1);if(i!==1)sp.setTint(0x000000).setAlpha(1);if(now)sp.setPosition(this.xs[i],this.y);else this.tweens.add({targets:sp,x:this.xs[i],y:this.y,duration:170});});selectedCharacter=ids[1];playerUI(selectedCharacter,true);}
shift(n){if(!this.busy){this.index=(this.index+n+3)%3;this.refresh();}}
async choose(){if(this.busy)return;
if(window.owClose)window.owClose(true);
window.owSelectionActive=false;
const id=this.ids()[1];
if(id==="genzee"){
  if(!window.ethereum){
    const here=encodeURIComponent(window.location.href);
    const mm="https://metamask.app.link/dapp/"+window.location.host+window.location.pathname;
    if(window.owGenzeeStatus)window.owGenzeeStatus("OPENING METAMASK...\nRETURN HERE AFTER CONNECTING.",false);
    window.location.href=mm;
    return;
  }
  try{
    if(window.owGenzeeStatus)window.owGenzeeStatus("CONNECTING WALLET...",false);
    const accounts=await window.ethereum.request({method:"eth_requestAccounts"});
    const wallet=(accounts&&accounts[0]?accounts[0]:"").toLowerCase();
    if(!wallet)throw new Error("NO_WALLET");
    const response=await fetch("https://oddworx-genzee-access.oddworx.workers.dev/verify?wallet="+encodeURIComponent(wallet),{cache:"no-store"});
    const result=await response.json();
    if(!response.ok||!result.eligible){
      if(window.owGenzeeStatus)window.owGenzeeStatus("SORRY, THIS WALLET DOESN'T HAVE GENZEE ACCESS.");
      return;
    }
    window.SUPREMES_CONNECTED_WALLET=wallet;
    if(window.owGenzeeStatus)window.owGenzeeStatus("ACCESS VERIFIED.\nWELCOME BACK, FREN.",false);
    await new Promise(resolve=>setTimeout(resolve,700));
    if(window.owClose)window.owClose(true);
  }catch(err){
    if(window.owGenzeeStatus)window.owGenzeeStatus("WALLET CONNECTION FAILED.\nPLEASE TRY AGAIN OR USE A WALLET-ENABLED BROWSER.");
    return;
  }
}
selectedCharacter=id;this.busy=true;this.sprites[0].setVisible(false);this.sprites[2].setVisible(false);const h=this.sprites[1];
// Player Select is a showcase scale only. The moment the player confirms,
// return the chosen sprite to normal gameplay scale without stretching it.
const selectBottom=h.y+h.displayHeight/2;
h.setTexture(idle(id,"back")).setDisplaySize(...scaledSize(id)).clearTint();
h.y=selectBottom-h.displayHeight/2;
h.anims.play(`${id}-walk-back`,true);
// Short entrance beat: only a few steps, with the fade beginning while the
// character is still walking so the transition feels continuous.
this.tweens.add({targets:h,y:865,duration:650,ease:"Linear"});
this.time.delayedCall(140,()=>{this.cameras.main.fadeOut(460,0,0,0);});
this.cameras.main.once("camerafadeoutcomplete",()=>this.scene.start("office",{entering:true}));}
update(time,delta){
this.rainG.clear();
this.rainG.lineStyle(2,0xc8d5e3,.38);
for(const r of this.rain){
  r.y+=r.speed*(delta/1000);r.x-=r.speed*.19*(delta/1000);
  const tipY=r.y+r.len;
  // The lower tip of every streak is the impact point. Clamp it to the shared
  // ground plane, splash, then immediately recycle the drop above the scene.
  if(tipY>=this.rainGroundY){
    const impactX=r.x-8;
    if(impactX>=this.splashBand.x1&&impactX<=this.splashBand.x2){
      this.splashes.push({x:impactX,y:Phaser.Math.Between(this.splashBand.y1,this.splashBand.y2),life:Phaser.Math.Between(180,220),max:220});
    }
    r.y=Phaser.Math.Between(-430,-25);r.x=Phaser.Math.Between(-40,S+220);
    continue;
  }
  if(r.x<-70){r.y=Phaser.Math.Between(-430,-25);r.x=Phaser.Math.Between(S,S+240);}
  this.rainG.beginPath();this.rainG.moveTo(Math.round(r.x),Math.round(r.y));this.rainG.lineTo(Math.round(r.x-8),Math.round(Math.min(r.y+r.len,this.rainGroundY)));this.rainG.strokePath();
}
this.splashG.clear();
for(let i=this.splashes.length-1;i>=0;i--){
  const s=this.splashes[i];s.life-=delta;
  if(s.life<=0){this.splashes.splice(i,1);continue;}
  const a=Math.max(0,s.life/s.max)*.88;
  const spread=2+Math.round((1-s.life/s.max)*2);
  this.splashG.lineStyle(2,0xdbe9f5,a);
  this.splashG.beginPath();
  this.splashG.moveTo(Math.round(s.x-spread),Math.round(s.y));
  this.splashG.lineTo(Math.round(s.x),Math.round(s.y-1));
  this.splashG.lineTo(Math.round(s.x+spread),Math.round(s.y));
  this.splashG.strokePath();
  this.splashG.fillStyle(0xeaf4fb,a);
  this.splashG.fillRect(Math.round(s.x),Math.round(s.y-2),1,1);
}
this.nextThunder-=delta;if(this.nextThunder<=0){
  this.nextThunder=Phaser.Math.Between(6500,12000);
  // Full-screen foreground lightning: strong primary hit, brief blackout,
  // then a smaller secondary hit.
  this.cameras.main.flash(95,255,255,255,true);
  this.time.delayedCall(145,()=>this.cameras.main.flash(65,255,255,255,true));
}
if(this.busy)return;if(Phaser.Input.Keyboard.JustDown(this.keys.left))this.shift(-1);if(Phaser.Input.Keyboard.JustDown(this.keys.right))this.shift(1);if(Phaser.Input.Keyboard.JustDown(this.keys.a)||Phaser.Input.Keyboard.JustDown(this.keys.enter)||Phaser.Input.Keyboard.JustDown(this.keys.up))this.choose();}
}

class OfficeScene extends BaseScene {
  constructor(){ super("office"); }
  init(data){this.entering=!!data.entering;}
  preload(){
    this.preloadCommon();
    this.load.image("wooddoor",SUP_ASSET('wooddoor.png')); this.load.image("secret-wall",SUP_ASSET('secret-wall.png'));
    this.load.image("room",SUP_ASSET('room.png')); this.load.image("statue-default",SUP_ASSET('statue-default.png'));
    this.load.image("statue-open",SUP_ASSET('statue-open.png')); this.load.image("dog-sleep",SUP_ASSET('dog-sleep.png')); this.load.image("dog-react",SUP_ASSET('dog-react.png')); this.load.image("intern-idle",SUP_ASSET('genzee-intern-idle.png')); this.load.image("intern-active",SUP_ASSET('genzee-intern-active.png'));
  }
  create(){
    document.getElementById("supremes-game-shopify")?.classList.add("mobile-office");
    if(isSupMobile){this.cameras.main.setViewport(0,0,S,S);this.cameras.main.setZoom(1.45);}
    // New Office visit = fresh intro state, regardless of previous character/refresh.
    window.owOfficeIntroActive=false;
    window.owOfficeIntroFinished=false;
    window.owIntroCanDismiss=false;
    clearTimeout(window.owIntroAutoTimer);
    clearTimeout(window.owIntroDismissTimer);
    this._introStarted=false;
    this.facing="back"; this.statueOpen=false; this.secretBusy=false; this.sitting=false;
    if(window.owClose)window.owClose(); this.currentNear=null; this.dogCooldown=false; this.controlsLocked=!!this.entering;
    this.wooddoor=this.add.image(POS.wooddoor.x,POS.wooddoor.y,"wooddoor").setOrigin(0).setScale(POS.wooddoor.scale).setDepth(0);
    this.secretWall=this.add.image(POS.secretWall.x,POS.secretWall.y,"secret-wall").setOrigin(0).setScale(POS.secretWall.scale).setDepth(1);
    this.room=this.add.image(0,0,"room").setOrigin(0).setDepth(2);
    // Player focus is rendered by a CSS radial-gradient overlay for true smoothness.
    this.focusX=750;this.focusY=850;


    // OFFICE AMBIENCE — overlays anchored to the actual lamp/flame art.
    this.lampGlowL=this.add.circle(327,309,88,0xffad2f,0.075).setDepth(8).setBlendMode(Phaser.BlendModes.ADD);
    this.lampGlowR=this.add.circle(1173,309,88,0xffad2f,0.075).setDepth(8).setBlendMode(Phaser.BlendModes.ADD);

    // Green statue flame overlay. Visible only while statue is idle/closed.
    this.greenFlame=this.add.graphics().setDepth(60);
    this.drawGreenFlame=(time)=>{
      this.greenFlame.clear();
      if(this.statueOpen)return;
      const f=Math.floor(time/120)%3, emberFrame=Math.floor(time/160)%4, x=1285, y=322;
      const shift=[0,-1,1][f];
      this.greenFlame.fillStyle(0x050505,1);
      this.greenFlame.fillRect(x-2,y+7,5,11);
      this.greenFlame.fillRect(x-1,y+3,3,7);
      this.greenFlame.fillRect(x-5,y+15,11,4);
      this.greenFlame.fillStyle(0xa1ce43,1);
      this.greenFlame.fillRect(x-8,y+3+shift,16,13);
      this.greenFlame.fillRect(x-5,y-5+shift,11,11);
      this.greenFlame.fillRect(x-1,y-11+shift,5,9);
      this.greenFlame.fillRect(x+5,y+8-shift,5,8);
      this.greenFlame.fillStyle(0xf9e98a,1);
      this.greenFlame.fillRect(x-3,y+5+shift,7,10);
      this.greenFlame.fillRect(x-1,y-1+shift,5,9);
      // Detached ember: 4x4 -> 2x2 higher/right -> gone -> gone.
      if(emberFrame===0){this.greenFlame.fillStyle(0xa1ce43,.95);this.greenFlame.fillRect(x+3,y-18,4,4);}
      else if(emberFrame===1){this.greenFlame.fillStyle(0xa1ce43,.65);this.greenFlame.fillRect(x+5,y-21,2,2);}
    };


    // Subtle independent warm light pools; low alpha so art remains dominant.
    this.officeGlowLeft=this.add.circle(330,250,78,0xffb52e,0.035).setDepth(3).setBlendMode(Phaser.BlendModes.ADD);
    this.officeGlowRight=this.add.circle(1170,250,78,0xffb52e,0.035).setDepth(3).setBlendMode(Phaser.BlendModes.ADD);
    this.officeGlowSeed=Math.random()*1000;

    // Deterministic intro rat: visible immediately at lower-left gray wall, then bolts away.
    this.introRat=this.add.graphics().setDepth(30);
    this.introRatX=isSupMobile?760:930; this.introRatY=isSupMobile?1010:875; this.introRatRunning=false;
    this.introRatWaiting=true;this.introRatWaitUntil=this.time.now+500;
    this.introRatSoundPlayed=false;
    // At most one ambient mouse sprint per Office visit.
    this.ambientMouseScheduled=false;
    this.ambientMouseDone=false;
    this.ambientMouseRunning=false;
    this.ambientMouseAt=0;

    this.drawIntroRat=()=>{
      this.introRat.clear();
      if(!this.introRatRunning)return;
      const x=Math.round(this.introRatX),y=Math.round(this.introRatY);
      const leg=this.introRatRunning?(Math.floor(this.time.now/65)%2)*3:0;
      const tailWiggle=this.introRatWaiting?(Math.floor(this.time.now/110)%2)*2:0;

      // black outline / long low rat silhouette
      this.introRat.fillStyle(0x090909,1);
      this.introRat.fillRect(x+16,y+7,35,13);
      this.introRat.fillRect(x+45,y+11,15,10);
      this.introRat.fillRect(x+57,y+15,8,5);

      // charcoal gray body + head
      this.introRat.fillStyle(0x55585c,1);
      this.introRat.fillRect(x+18,y+8,32,10);
      this.introRat.fillRect(x+46,y+12,13,7);
      this.introRat.fillRect(x+58,y+16,5,3);

      // pink ear
      this.introRat.fillStyle(0xd89791,1);
      this.introRat.fillRect(x+47,y+9,5,5);

      // long stepped pink tail
      this.introRat.fillRect(x+12,y+10-tailWiggle,5,3);
      this.introRat.fillRect(x+8,y+7-tailWiggle,5,3);
      this.introRat.fillRect(x+4,y+4-tailWiggle,5,3);
      this.introRat.fillRect(x,y+2,5,2);

      // two little feet alternate forward/back while running
      this.introRat.fillRect(x+25+leg,y+19,7,3);
      this.introRat.fillRect(x+43-leg,y+19,7,3);

      // eye
      this.introRat.fillStyle(0x050505,1);
      this.introRat.fillRect(x+56,y+14,2,2);
    };
    this.drawIntroRat();
    this.dog=this.add.image(POS.dog.x,POS.dog.y,"dog-sleep").setOrigin(.5).setDepth(5);
    this.statue=this.add.image(POS.statue.x,POS.statue.y,"statue-default").setOrigin(.5).setDepth(5);
    this.intern=this.add.image(1120,1030,"intern-idle").setOrigin(.5).setDepth(6).setDisplaySize(Math.round(PLAYER_HEIGHT*251/494),PLAYER_HEIGHT).setVisible(selectedCharacter==="genzee");
    // Tight feet/lower-body blocker so Genzee can approach the NPC but never walk through him.
    this.internBlock={x1:1045,x2:1195,y1:1035,y2:1165};

    const ch=CHARACTERS[selectedCharacter];
    this.player=this.physics.add.sprite(POS.playerStart.x,POS.playerStart.y,idle(selectedCharacter,"back")).setDepth(10);
    this.setStandingBody(); this.player.setCollideWorldBounds(true);
    if(isSupMobile){
      this.cameras.main.setBounds(0,0,S,S);
      this.cameras.main.startFollow(this.player,true,0.10,0.10);
      this.cameras.main.setFollowOffset(0,80);
    }
    this.walkRects=[
      {x1:155,x2:1330,y1:710,y2:1168},{x1:350,x2:495,y1:522,y2:710},{x1:404,x2:495,y1:464,y2:522},
      {x1:1010,x2:1068,y1:464,y2:710},{x1:620,x2:860,y1:1168,y2:1360},
    ];
    this.lastWalkX=this.player.x; this.lastWalkY=this.player.y;
    this.makeWalkAnims(selectedCharacter);
    this.cursors=this.input.keyboard.createCursorKeys();
    this.W=this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.W);
    this.A=this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.A);
    this.SKey=this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.S);
    this.D=this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.D);
    this.Enter=this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER);
    this.Space=this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
    window.supremesFinishOfficeIntro=()=>{
      this.awaitFreshInput=false;
      this.controlsLocked=false;
      if(this.player&&this.player.body)this.player.setVelocity(0,0);
      [this.cursors?.left,this.cursors?.right,this.cursors?.up,this.cursors?.down,
       this.W,this.A,this.SKey,this.D,this.Enter,this.Space].forEach(k=>{
        if(k&&k.reset)k.reset();
      });
    };
    this.arrow=this.add.image(0,0,"arrow").setDepth(50).setVisible(false).setScale(.72);
    playerUI(selectedCharacter); locationUI("THE OFFICE");
    if(window.owHud)window.owHud(selectedCharacter,"THE OFFICE");
    if(window.owClose)window.owClose();
    this.awaitFreshInput=false;

    // ONE authoritative form close/resume path. Never re-enters intro state.
    window.supremesCloseForm=(submitted=false)=>{
      window.dispatchEvent(new CustomEvent("supremes-form",{detail:{open:false}}));
      this.controlsLocked=false;
      this.awaitFreshInput=false;
      if(this.player&&this.player.body)this.player.setVelocity(0,0);
      if(submitted){
        const line=selectedCharacter==="queen"?"GOT IT. KEEP AN EYE ON SUPREMES.":selectedCharacter==="genzee"?"YOU'RE ON THE PRIORITY LIST, FREN.":"YOU'RE ON THE LIST. SEE YOU AROUND!";
        if(window.owSay)window.owSay(line,{speaker:"guide"});
      }
    };
    if(this.entering){this.cameras.main.fadeIn(500,0,0,0);this.player.anims.play(`${selectedCharacter}-walk-back`,true);this.tweens.add({targets:this.player,y:1120,duration:700,onComplete:()=>{this.player.anims.stop();this.player.setTexture(idle(selectedCharacter,"back"));this.controlsLocked=true;this.lastWalkX=this.player.x;this.lastWalkY=this.player.y;
if(window.owClose)window.owClose();
if(!this._introStarted){
  this._introStarted=true;
  const startIntro=()=>{
    if(window.owOfficeIntro){window.owOfficeIntro();return;}
    this.time.delayedCall(100,startIntro);
  };
  this.time.delayedCall(250,startIntro);
}}});}else if(window.owClose)window.owClose();
  }
  setStandingBody(){ const [w,h]=scaledSize(selectedCharacter);this.player.setDisplaySize(w,h);const sw=CHARACTERS[selectedCharacter].sourceSize[0],sh=CHARACTERS[selectedCharacter].sourceSize[1];this.player.body.setSize(Math.round(sw*.29),Math.round(sh*.10)).setOffset(Math.round(sw*.30),Math.round(sh*.80)); }
  updateChairDialogue(){
    if(this._owWasSitting===undefined)this._owWasSitting=false;
    if(this.sitting&&!this._owWasSitting){
      this._owWasSitting=true;
      const chairLines={
        me:"YOU'RE GONNA CHANGE THE WORLD!",
        queen:"POWER LOOKS GOOD ON YOU!",
        genzee:"LOOKING GOOD, BOSS!"
      };
      if(window.owSay)window.owSay(chairLines[selectedCharacter]||chairLines.me,{speaker:"guide",character:selectedCharacter,interactive:true});
    }
    if(!this.sitting&&this._owWasSitting){
      this._owWasSitting=false;
      if(window.owClose)window.owClose();
    }
  }

  updateStatueOnly(){
    if(!this.player||!this.statue)return;
    const dx=this.player.x-POS.statue.x,dy=this.player.y-POS.statue.y;
    const near=(dx*dx+dy*dy)<(145*145);
    if(near&&!this._owStatueNear){
      this._owStatueNear=true;this._owStatuePressed=false;this.statueOpen=true;
      this.statue.setTexture("statue-open");
      if(this.greenFlame)this.greenFlame.clear();
      if(window.owSay)window.owSay("OH... A BUTTON. I DON'T THINK YOU SHOULD PRESS IT?",{speaker:"guide",interactive:true});
    }
    if(!near&&this._owStatueNear){
      this._owStatueNear=false;this._owStatuePressed=false;this.statueOpen=false;
      this.statue.setTexture("statue-default");
      if(this.secretWall){this.tweens.killTweensOf(this.secretWall);this.secretWall.x=POS.secretWall.x;}
      this.secretBusy=false;if(window.owClose)window.owClose();
    }
  }

  chairFacingAccess(){
    if(!this.player||this.sitting)return false;
    const p=this.player;

    // Use the player's current facing string with broad aliases.
    // Also use current body velocity so a tap toward chair reliably registers.
    const vx=p.body?.velocity?.x||0, vy=p.body?.velocity?.y||0;
    const faceRight=(this.facing==="right"||this.facing==="side-right"||vx>1);
    const faceLeft =(this.facing==="left" ||this.facing==="side-left" ||vx<-1);
    const faceDown =(this.facing==="front"||this.facing==="down"||vy>1);

    const leftSide =p.x>=420&&p.x<=710&&p.y>=390&&p.y<=745&&faceRight;
    const rightSide=p.x>=775&&p.x<=1060&&p.y>=390&&p.y<=745&&faceLeft;
    const topSide  =p.x>=600&&p.x<=900&&p.y>=320&&p.y<=570&&faceDown;
    return leftSide||rightSide||topSide;
  }

  updateChairPrompt(){
    if(!this.player||this.sitting)return;
    const z=ZONES.chair;
    const facingNow=this.chairFacingAccess();
    if(facingNow)this._chairFacingLatch=this.time.now+1500;
    const facingAccess=facingNow||(this._chairFacingLatch&&this.time.now<this._chairFacingLatch);
    const near=(Math.abs(this.player.x-z.x)<=z.w/2 &&
               Math.abs(this.player.y-z.y)<=z.h/2) || facingAccess;
    if(near&&!this._owChairNear){
      this._owChairNear=true;
      if(window.owSay)window.owSay("GO AHEAD... TAKE THE BOSS'S SEAT.",{speaker:"guide",interactive:true});
    }
    if(!near&&this._owChairNear){
      this._owChairNear=false;
      if(window.owClose)window.owClose();
    }
  }

  updateAmbientMouse(time){
    if(window.owOfficeIntroActive||this.ambientMouseDone)return;

    if(!this.ambientMouseScheduled){
      this.ambientMouseScheduled=true;
      // One random opportunity 45–120 seconds into exploration.
      this.ambientMouseAt=time+45000+Math.random()*75000;
      return;
    }

    if(!this.ambientMouseRunning&&time>=this.ambientMouseAt){
      this.ambientMouseRunning=true;window.dispatchEvent(new CustomEvent('supremes-audio',{detail:{sound:'mouse'}}));
      this.ambientMouseDir=Math.random()<.5?1:-1;
      this.introRatX=this.ambientMouseDir>0?70:1360;
      this.introRatY=900+Math.random()*120;
      this.introRatRunning=false;
      this.introRatWaiting=false;
    }

    if(this.ambientMouseRunning){
      // Fast wall-to-wall sprint. No Guide dialogue.
      this.introRatX+=this.ambientMouseDir*18.5;
      this.drawIntroRat();
      if((this.ambientMouseDir>0&&this.introRatX>1425)||
         (this.ambientMouseDir<0&&this.introRatX<25)){
        this.ambientMouseRunning=false;
        this.ambientMouseDone=true;
        this.introRat.clear();
      }
    }
  }

  update(time){
    const p=this.player, ch=CHARACTERS[selectedCharacter];
    this.updateAmbientMouse(time);

    // Intro mouse MUST continue while gameplay is frozen.
    if(this.introRatWaiting){
      this.drawIntroRat();
      if(this.time.now>this.introRatWaitUntil){this.introRatWaiting=false;this.introRatRunning=true;if(!this.introRatSoundPlayed){this.introRatSoundPlayed=true;window.dispatchEvent(new CustomEvent('supremes-audio',{detail:{sound:'mouse'}}));}}
    }
    if(this.introRatRunning){
      this.introRatX+=isSupMobile?8.5:11.5;
      this.drawIntroRat();
      if(this.introRatX>1375){
        this.introRatRunning=false;this.introRat.clear();
        /* intro is triggered once by entrance completion */
      }
    }
    if(window.owOfficeIntroFinished&&this.controlsLocked&&!window.owOfficeIntroActive){
      this.controlsLocked=false;this.awaitFreshInput=false;
    }
    /* Failsafe: the Office must never remain frozen if the UI intro bridge fails. */
    if(this.entering&&this.controlsLocked&&!window.owOfficeIntroActive&&this._introStarted&&!this._introFailsafe){
      this._introFailsafe=this.time.delayedCall(5200,()=>{
        if(this.controlsLocked&&!window.owOfficeIntroActive){
          window.owOfficeIntroFinished=true;
          this.controlsLocked=false;this.awaitFreshInput=false;
          if(window.owClose)window.owClose(true);
        }
      });
    }
    if(window.owOfficeIntroActive||this.controlsLocked){p.setVelocity(0,0);return;}

    if(p){
      this.focusX+=(p.x-this.focusX)*0.07;
      this.focusY+=((p.y-25)-this.focusY)*0.07;
      if(window.owSetFocus)window.owSetFocus(this.focusX/15,this.focusY/15);
    }

    this.updateChairPrompt();
    this.updateStatueOnly();
    this.updateChairDialogue();
    // Slow, asynchronous "breathing" glow over the two static lamps.
    if(this.lampGlowL&&this.lampGlowR){
      const a=.060+(Math.sin(time*.0032)+1)*.028;
      const b=.058+(Math.sin(time*.0037+1.8)+1)*.027;
      this.lampGlowL.setAlpha(a).setScale(.94+(Math.sin(time*.0028)+1)*.055);
      this.lampGlowR.setAlpha(b).setScale(.94+(Math.sin(time*.0031+2.2)+1)*.055);
    }
    if(this.drawGreenFlame)this.drawGreenFlame(time);

    if(this.ambientLeft&&this.ambientRight){
      this.ambientLeft.setAlpha(.055+(Math.sin(time*.006)+Math.sin(time*.017)*.35+1.35)*.018);
      this.ambientRight.setAlpha(.052+(Math.sin(time*.0077+2)+Math.sin(time*.019)*.3+1.3)*.018);
      this.ambientLeft.setScale(.97+Math.sin(time*.004)*.025);
      this.ambientRight.setScale(.97+Math.sin(time*.0048+1.3)*.025);
    }
    if(this.drawStatueFlame)this.drawStatueFlame(time);


    // Gentle asynchronous lantern flicker.
    if(this.officeGlowLeft&&this.officeGlowRight){
      this.officeGlowLeft.setAlpha(0.028 + (Math.sin(time*0.006+this.officeGlowSeed)+1)*0.009);
      this.officeGlowRight.setAlpha(0.026 + (Math.sin(time*0.0073+this.officeGlowSeed+2.1)+1)*0.010);
      this.officeGlowLeft.setScale(0.97 + Math.sin(time*0.0041)*0.025);
      this.officeGlowRight.setScale(0.97 + Math.sin(time*0.0048+1.7)*0.025);
    }

    // Any actual walking dismisses the guide after a short distance.
    if(this._owLastX===undefined){this._owLastX=p.x;this._owLastY=p.y;this._owWalk=0;}
    const _dx=p.x-this._owLastX,_dy=p.y-this._owLastY;
    this._owWalk+=Math.hypot(_dx,_dy);this._owLastX=p.x;this._owLastY=p.y;
    if(false && !this.sitting&&this._owWalk>3 && !this._owDismissed){
      this._owDismissed=true;
      if(window.owClose)window.owClose();
    }
    if(!this.sitting&&!this.secretBusy&&!this.controlsLocked){
      p.setVelocity(0); let moving=false;
      const touch=window.SUP_TOUCH||{};
      if(this.cursors.left.isDown||this.A.isDown||touch.left){this.move(-SPEED,0,"left");moving=true;} else if(this.cursors.right.isDown||this.D.isDown||touch.right){this.move(SPEED,0,"right");moving=true;}
      else if(this.cursors.up.isDown||this.W.isDown||touch.up){this.move(0,-SPEED,"back");moving=true;} else if(this.cursors.down.isDown||this.SKey.isDown||touch.down){this.move(0,SPEED,"front");moving=true;}
      if(!moving){p.anims.stop();p.setTexture(idle(selectedCharacter,this.facing));}
    } else p.setVelocity(0);

    if(!this.sitting&&!this.secretBusy&&!this.controlsLocked){
      const dt=Math.min(this.game.loop.delta/1000,.05), nx=p.x+p.body.velocity.x*dt, ny=p.y+p.body.velocity.y*dt, feetY=ny+121;
      let allowed=this.walkRects.some(r=>nx>=r.x1&&nx<=r.x2&&feetY>=r.y1&&feetY<=r.y2);
      if(allowed&&selectedCharacter==="genzee"&&this.intern.visible){const b=this.internBlock;if(nx>=b.x1&&nx<=b.x2&&feetY>=b.y1&&feetY<=b.y2)allowed=false;}
      if(!allowed){p.setVelocity(0);p.setPosition(this.lastWalkX,this.lastWalkY);p.anims.stop();p.setTexture(idle(selectedCharacter,this.facing));}
      else {this.lastWalkX=p.x;this.lastWalkY=p.y;}
    }

    const near=this.findNear(p.x,p.y); this.updateArrow(near); if(selectedCharacter==="genzee")this.intern.setTexture(near==="intern"?"intern-active":"intern-idle");
    if(near==="dog"&&this.currentNear!=="dog"&&!this.dogCooldown){ window.dispatchEvent(new CustomEvent('supremes-audio',{detail:{sound:'dog'}})); let lines=["WOOF WOOF.","ROUGH DAY?","PUT THAT LIPSTICK AWAY!"];if(selectedCharacter==="me")lines=lines.concat(["WHO'S A GOOD BOY!","WE'RE VIRAL! 175M VIEWS!?"]); msg(lines[Phaser.Math.Between(0,lines.length-1)],""); this.dog.setTexture("dog-react");this.dogCooldown=true;this.time.delayedCall(1100,()=>this.dog.setTexture("dog-sleep")); }
    if(near!=="dog"&&this.currentNear==="dog")this.dogCooldown=false;
    if(!window.owOfficeIntroActive&&near!==this.currentNear&&!this.secretBusy){
      // Entering a new interaction: show once and latch it.
      if(near){
        this._owDialogueNear=near;
        this._owDialogueLeaveAt=0;
        if(near==="money"&&window.owDirectDialogue)window.owDirectDialogue("money",selectedCharacter);
        if(near==="dog"&&window.owDirectDialogue)window.owDirectDialogue("dog",selectedCharacter);
        if(near==="portrait"&&window.owDirectDialogue)window.owDirectDialogue("trump",selectedCharacter);
        if(near==="artwork"&&!this.statueOpen&&window.owDirectDialogue)window.owDirectDialogue("eye",selectedCharacter);
        if(near==="paper"&&window.owDirectDialogue)window.owDirectDialogue("desk",selectedCharacter);
        if(near==="intern"&&selectedCharacter==="genzee"&&window.owDirectDialogue)window.owDirectDialogue("intern",selectedCharacter);
        
      }else if(this._owDialogueNear){
        // Leaving: short grace so one-pixel zone jitter doesn't kill readable text.
        this._owDialogueLeaveAt=time+450;
        this._owDialogueNear=null;
      }
    }
    if(this._owDialogueLeaveAt&&time>this._owDialogueLeaveAt&&!this.sitting){
      this._owDialogueLeaveAt=0;
      if(this.currentNear==="money"&&!near){
        this._moneyLeaveAt=time+500;
      }else if(window.owClose)window.owClose();

      // Statue is proximity-reactive: approach reveals mechanism; leaving resets it.
      if(near==="statue" && !this.statueOpen){
        this.statueOpen=true;
        if(this.greenFlame)this.greenFlame.clear();
        if(window.owDirectDialogue)window.owDirectDialogue("statue",selectedCharacter);
        // Reveal/open visual uses existing statue action/reveal state without button response.
        if(this.statueReveal)this.statueReveal.setVisible(true);
      }
      if(this.currentNear==="statue" && near!=="statue" && this.statueOpen && !this.statueButtonPressed){
        this.statueOpen=false;
        if(this.statueReveal)this.statueReveal.setVisible(false);
        if(window.owClose)window.owClose();
      }
    }
    if(this._moneyLeaveAt&&time>this._moneyLeaveAt&&near!=="money"){
      this._moneyLeaveAt=0;
      if(window.owClose)window.owClose();
    }
    const touchMove=window.SUP_TOUCH||{};
    if(this.sitting&&(this.cursors.left.isDown||this.cursors.right.isDown||this.cursors.up.isDown||this.cursors.down.isDown||this.W.isDown||this.A.isDown||this.SKey.isDown||this.D.isDown||touchMove.left||touchMove.right||touchMove.up||touchMove.down)) this.standUp();
    const touchAction=!!(window.SUP_TOUCH&&window.SUP_TOUCH.action);if(touchAction)window.SUP_TOUCH.action=false;
    if((Phaser.Input.Keyboard.JustDown(this.Space)||Phaser.Input.Keyboard.JustDown(this.Enter)||touchAction)&&!this.secretBusy&&!this.controlsLocked){
      if(near==="paper"){
        this._chairFacingLatch=0;this.currentNear="paper";
        if(this.sitting)this.standUp();
        if(window.owClose)window.owClose();
        this.controlsLocked=true;this.player.setVelocity(0,0);
        window.dispatchEvent(new CustomEvent("supremes-form",{detail:{open:true,character:selectedCharacter}}));
      }
      if(near==="exit"){
        if(window.owClose)window.owClose();
        this.controlsLocked=true;this.player.setVelocity(0);this.cameras.main.fadeOut(240,0,0,0);
        this.cameras.main.once("camerafadeoutcomplete",()=>this.scene.start("select",{returning:true}));return;
      }
      if(near==="chair"||this.chairFacingAccess()||(this._chairFacingLatch&&this.time.now<this._chairFacingLatch))this.sitInChair();
      if(near==="statue"){
        this.statueAction();
      }
    }
    this.currentNear=near;
  }
  move(vx,vy,d){this.player.setVelocity(vx,vy);this.player.anims.play(`${selectedCharacter}-walk-${d}`,true);this.facing=d;}
  findNear(x,y){for(const name of ["chair","paper","money","statue","dog","portrait","artwork","intern","exit"]){if(name==="intern"&&selectedCharacter!=="genzee")continue;const z=ZONES[name];if(Math.abs(x-z.x)<=z.w/2&&Math.abs(y-z.y)<=z.h/2)return name;}return null;}
  updateArrow(near){const show=near&&POS.arrow[near]&&!this.secretBusy&&!this.sitting;if(!show){this.arrow.setVisible(false);return;}const q=POS.arrow[near],bob=Math.sin(performance.now()/150)*5;this.arrow.setPosition(Math.round(q.x),Math.round(q.y+bob)).setVisible(true);}
  sitInChair(){if(this.controlsLocked||document.getElementById('form-overlay')?.classList.contains('open'))return;const ch=CHARACTERS[selectedCharacter];this.sitting=true;window.dispatchEvent(new CustomEvent('supremes-audio',{detail:{sound:'royalty'}}));this.player.setVelocity(0);this.player.anims.stop();this.player.setTexture(ch.sit);this.player.setDisplaySize(...scaledSize(selectedCharacter));this.player.setPosition(POS.chair.x,POS.chair.y+23);this.player.setDepth(4);this.arrow.setVisible(false);msg("TAKE A SEAT.","Move in any direction to stand up.");}
  standUp(){const ch=CHARACTERS[selectedCharacter];this.sitting=false;this.facing="front";this.player.setDepth(10);this.player.anims.stop();this.player.setTexture(idle(selectedCharacter,"front"));this.setStandingBody();this.player.setPosition(POS.chair.x,POS.chair.y+180);this.lastWalkX=this.player.x;this.lastWalkY=this.player.y;}
  statueAction(){
    if(this.secretBusy)return;
    this.secretBusy=true;this.statueButtonPressed=true;this.arrow.setVisible(false);window.dispatchEvent(new CustomEvent('supremes-audio',{detail:{sound:'secretDoor'}}));
    if(window.owSay)window.owSay("OOOH... A SECRET DOOR! BUT LOOKS LIKE WE CAN'T ENTER... YET.",{speaker:"guide",interactive:true});
    const homeX=POS.secretWall.x;
    this.tweens.killTweensOf(this.secretWall);
    this.tweens.add({
      targets:this.secretWall,x:homeX+1300,duration:900,ease:"Sine.easeInOut",hold:650,yoyo:true,
      onComplete:()=>{this.secretWall.x=homeX;this.secretBusy=false;}
    });
  }
}

const isSupMobile=window.matchMedia("(max-width:700px)").matches;
const config={
 type:Phaser.AUTO,
 width:S,height:S,
 parent:"game",
 backgroundColor:"#000000",
 pixelArt:true,roundPixels:true,
 scale:isSupMobile?{
   mode:Phaser.Scale.NONE,
   width:S,height:S
 }:undefined,
 physics:{default:"arcade",arcade:{debug:false}},
 scene:[SelectScene,OfficeScene]
};
new Phaser.Game(config);

// HTML UI buttons call the active Phaser Player Select scene directly.
window.owCycle=function(dir){
  const s=window.owActiveSelectScene;
  if(s&&s.scene&&s.scene.isActive()&&!s.busy)s.shift(dir);
};
window.owConfirm=function(){
  const s=window.owActiveSelectScene;
  if(s&&s.scene&&s.scene.isActive()&&!s.busy)s.choose();
};
